import Vue from 'vue';
import Transitions from 'vue2-transitions';
import { MediaQueries } from 'vue-media-queries';

// Common library for all our @holdingblachere Vue App
import { ShopAuthManager, ShopSessionManager } from '@holdingblachere/js-sdk';
import { ShopLoginPlugin, AdminLoginPlugin } from '@holdingblachere/vue-common-ui';
import '@holdingblachere/vue-common-ui/dist/mb-vue-common-ui.css';

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import locale from 'element-ui/lib/locale/lang/fr';
import App from './App.vue';
import router from './router';
import store from './store';

// i18n
import i18n from './i18n/i18n';

// Firebase
import './vendors/firebase/firebase';

// Mixpanel
import mixpanel from './vendors/mixpanel/mixpanel';

Vue.prototype.$mixpanel = mixpanel;

Vue.use(Transitions);

// Instantiate the @holdingblachere library
const shopAuthManager = new ShopAuthManager({
  AMCBackendUrl: process.env.VUE_APP_MON_COMPTE_BACKEND_URL,
});

Vue.use(ShopLoginPlugin, {
  router,
  shopAuthProvider: shopAuthManager,
  store,
});

const shopSessionManager = new ShopSessionManager({
  url: process.env.VUE_APP_MON_COMPTE_BACKEND_URL,
});

Vue.use(AdminLoginPlugin, {
  shopSessionManager,
  afterLoginRoute: 'ManageUsers',
  loginWithCustomTokenAction: 'auth/loginWithCustomToken',
});

Vue.use(ElementUI, { locale });

Vue.config.productionTip = false;

const mediaQueries = new MediaQueries();

Vue.use(mediaQueries);

new Vue({
  router,
  store,
  i18n,
  mediaQueries,
  render: (h) => h(App),
}).$mount('#app');
